module.exports = __webpack_public_path__ + "img/产品观.0e51b13c.webp";